import {SectionBgView} from '../../ui_canvas_engine/SectionBgView'
import {UIGameRankedEndController} from './UIGameRankedEndController'

export abstract class BaseEndGameRankedChangeView {
    readonly uiGameRankedEndController: UIGameRankedEndController
    readonly contentContainer: SectionBgView
    readonly sectionSize: number

    constructor(uiGameRankedEndController: UIGameRankedEndController) {
        this.uiGameRankedEndController = uiGameRankedEndController
        this.contentContainer = uiGameRankedEndController.contentContainer
        this.sectionSize = uiGameRankedEndController.sectionSize
    }

    abstract hide()
}
